// eslint-disable-next-line import/prefer-default-export
export const SELECTED_THEME = 'SELECTED_THEME';
